import moment from 'moment';
import request from "./axios";

function index(params) {
  if (params.filter.begin) params.begin = moment(params.filter.begin).toDate()
  if (params.filter.end) params.end = moment(params.filter.end).toDate()
  params.assigned_to = params.filter.assigned
  params.include_completed = params.filter.includeCompleted
  delete (params.filter)
  return request({
    method: "get",
    url: `/trial_coaching_sessions`,
    params: params
  })
}

function get(id) {
  return request({
    method: "get",
    url: `/trial_coaching_sessions/${id}`
  })
}

function getAssignees(id) {
  return request({
    method: "get",
    url: `/trial_coaching_sessions/${id}/possible_assignees`
  })
}


function stats(email) {
  return request({
    method: "get",
    url: `/trial_coaching_sessions/stats?restrict_to=${email}`
  })
}

function update(id, params) {
  return request({
    method: "patch",
    url: `/trial_coaching_sessions/${id}`,
    data: { trial_coaching_session: params }
  })
}

function takeAction(action, id, params) {
  return request({
    method: "post",
    url: `/trial_coaching_sessions/${id}/action/${action}`,
    data: { trial_coaching_session_action: params }
  })
}

const TrialCoachingSessionsService = {
  index, get, update, takeAction, stats, getAssignees
};

export default TrialCoachingSessionsService;
